import { API } from '@/api';
import { theme } from '@/utils/theme';
import type { UpdateKeypointData } from './types';

export const classes = {
  card: 'flex flex-col shrink-0 p-0 my-2 border border-grey-3',
  auroraCard:
    'rounded-[14px] border-black/10 bg-white/90 shadow-aurora-card overflow-hidden dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  header: 'mb-1',
  contentWrapper: 'content-wrapper px-[13px] py-3 flex flex-col',
  content: 'mt-0 mb-1',
  linkWrapper: 'flex items-center mb-2',
  linkName:
    'ml-2 text-sm text-grey-7 hover:underline cursor-pointer outline-none',
  caseType: 'size-6 rounded-md p-0',
  caseTypeIcon: 'size-5',
};

export const styles = {
  point: {
    filter: 'drop-shadow(0 2px 4px hsla(229, 88%, 34%, 0.25))',
  },
  card: {
    '& .options-wrapper': {
      opacity: '0',
      transition: 'opacity 0.1s',
    },
    '&:hover .content-wrapper .options-wrapper': {
      opacity: '1',
    },
  },
  auroraDark: {
    '.dark &': {
      '& .text-grey-8': { color: theme.palette['mauve-1'].main },
      '& .text-grey-7': { color: theme.palette['mauve-2'].main },
      '& .text-grey-6': { color: theme.palette['mauve-3'].main },
      '& .bg-grey-2': { backgroundColor: 'rgba(255,255,255,0.04)' },
      '& .bg-grey-3': { backgroundColor: 'rgba(255,255,255,0.1)' },
    },
  },
};

export async function updateKeypoint(
  keypointId: number,
  data: UpdateKeypointData
) {
  return API.Keypoints.updateKeypoint(keypointId, {
    keypointTypeId: data.keypointTypeId,
    content: { message: data.message },
    // TODO: Change startsAt
  });
}
